// extracted by mini-css-extract-plugin
module.exports = {"notice":"Notice_notice__1udhI","article":"Notice_article__3YrW2","title":"Notice_title__1s8_W","date":"Notice_date__3jgxV"};